import Prefixer from 'inline-style-prefixer';

import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import fonts from '../../../../../../styles/fonts';

const footerHeight = 135;
const footerHeightSmall = 65;
const postMarginBottom = theme.spacing.xLarge;

const cellStyle = new Prefixer().prefix({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginBottom: postMarginBottom,
    position: 'relative',
  },
  cell: {
    width: '100%',
    maxWidth: 900,
    minWidth: 400,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingTop: theme.spacing.large,
    paddingBottom: theme.spacing.large,
    paddingLeft: theme.spacing.xxxLarge,
    paddingRight: theme.spacing.xxxLarge,
    borderRadius: 6,
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.3)',
  },
  previewPostSection: {
    width: 'calc(100% + 66.5px)',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: -52.5,
    marginBottom: 12,
  },
  separator: {
    backgroundColor: colors.grey3,
    height: 1,
    width: '100%',
    marginTop: 15,
    marginBottom: 25,
  },
  titleSection: {
    color: 'black',
    height: 'auto',
    fontSize: 16,
    marginBottom: 20,
  },
  contentSection: {
    // maxHeight: 350,
    position: 'relative',
    // overflow: 'hidden',
    marginBottom: 30,
  },
  editor: {
    width: '100%',
    overflow: 'auto',
  },
  contentGradient: {
    zIndex: 500,
    height: 30,
    position: 'absolute',
    left: 0,
    bottom: 0,
    background: `linear-gradient(${colors.postCellGradient})`,
  },
  readMore: {
    textAlign: 'center',
    fontSize: 14,
    color: colors.green0,
    cursor: 'pointer',
  },
  attachSection: {
    ...fonts.light,
    fontSize: 16,
    width: '100%',
  },
  footerContainer: {
    width: '100%',
    position: 'relative',
    bottom: 0,
    height: footerHeight,
  },
  footerContainerSmall: {
    height: footerHeightSmall,
  },
  bottomSection: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    fontSize: 14,
  },
  writeAnswerLabel: {
    ...fonts.regular,
    color: colors.grey6,
    fontSize: 14,
  },
  stats: {
    alignSelf: 'center',
  },
  numberLabel: {
    color: colors.green0,
    marginRight: 5,
  },
  recomIcon: {
    width: 15,
    height: 15,
  },
  edited: {
    fontSize: 16,
    color: colors.grayDark,
    marginBottom: 15,
    marginTop: -5,
    marginLeft: 52,
  },
  commentsContainer: {
    width: '100%',
  },
});

export default cellStyle;
